import React from 'react'
import TextField from 'Event/auth/Login/TextField'
import {useTemplate} from 'Event/TemplateProvider'
import {UseFormMethods} from 'react-hook-form'

export default function SignUpAdditionalFields(props: {
  submitting: boolean
  errors: Record<string, any>
  register: UseFormMethods['register']
}) {
  const {signUp} = useTemplate()
  const fields = signUp.additionalFields ?? []

  if (fields.length === 0) {
    return null
  }

  return (
    <>
      {fields.map((field) => {
        const label = field.label || field.groupKey
        return (
          <TextField
            key={field.groupKey}
            label={label}
            type="text"
            fullWidth
            variant="outlined"
            name={field.groupKey}
            disabled={props.submitting}
            inputProps={{
              ref: props.register({
                required: field.isRequired ? `${label} is required` : false,
              }),
              'aria-label': label,
            }}
            error={!!props.errors[field.groupKey]}
            helperText={props.errors[field.groupKey]}
          />
        )
      })}
    </>
  )
}
